import { getMainUserState } from '@/modules/main/selector';
import { Dispatch, SetStateAction, createContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocalStorage } from '../hooks/storage/useLocalStorage';
type liteUIState = {
    isLite: boolean;
    setIsLite: Dispatch<SetStateAction<boolean>>;
    // isFpsRunning: boolean;
    // fps: number;
    // averageFPS: number | undefined;
};
export const LiteUIContext = createContext({} as liteUIState);
const { Provider } = LiteUIContext;
type LiteUIProviderProps = {
    children: JSX.Element;
};
export const LiteUIProvider = ({ children }: LiteUIProviderProps) => {
    const { IsDemo } = useSelector(getMainUserState);
    const [isLite, setIsLite] = useLocalStorage('lite', false);
    // const { fps, isFpsRunning, averageFPS } = usePerformance();
    // const out = { isLite, setIsLite, fps, isFpsRunning, averageFPS };
    const out = { isLite, setIsLite };
    useEffect(() => {
        // local storage may return a non boolean value
        document.body.className = isLite === true && !IsDemo ? 'lite-ui' : '';
    }, [isLite, IsDemo]);
    return <Provider value={out}>{children}</Provider>;
};
